export const Cancelled = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="14" fill="#3D1010" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6701 11.6703C11.8897 11.4506 12.2459 11.4506 12.4656 11.6703L15.9998 15.2045L19.534 11.6703C19.7537 11.4506 20.1098 11.4506 20.3295 11.6703C20.5492 11.8899 20.5492 12.2461 20.3295 12.4658L16.7953 16L20.3295 19.5342C20.5492 19.7539 20.5492 20.1101 20.3295 20.3297C20.1098 20.5494 19.7537 20.5494 19.534 20.3297L15.9998 16.7955L12.4656 20.3297C12.2459 20.5494 11.8897 20.5494 11.6701 20.3297C11.4504 20.1101 11.4504 19.7539 11.6701 19.5342L15.2043 16L11.6701 12.4658C11.4504 12.2461 11.4504 11.8899 11.6701 11.6703Z"
      fill="#FF4336"
    />
  </svg>
);
